/**
 * Format a price (₹/kg) per the BST business rule:
 *   - Prices live in 0.5 increments
 *   - Display "55"   for 55
 *   - Display "55.5" for 55.5
 *   - Never display .00 or extra decimals
 *
 * Snaps any input to the nearest 0.5 before formatting (defensive).
 */
export const snapToHalf = (n) => {
  const x = Number(n);
  if (!Number.isFinite(x)) return 0;
  return Math.round(x * 2) / 2;
};

export const formatPrice = (n) => {
  const v = snapToHalf(n);
  // No decimal for whole numbers; exactly one for half-steps
  return Number.isInteger(v) ? String(v) : v.toFixed(1);
};

/** Validate an input string for 0.5 increments. Returns true if valid. */
export const isValidHalfStep = (raw) => {
  if (raw === "" || raw === null || raw === undefined) return false;
  const x = Number(raw);
  if (!Number.isFinite(x) || x < 0) return false;
  // Multiply by 2; result must be an integer
  return Number.isInteger(x * 2);
};
